import { WsBaseRequest } from 'api/ws/WsRequest';
import { API_TOURNAMENTS } from 'api/notificationManager/methods';

export default class TournamentsRequest extends WsBaseRequest {
  constructor() {
    super(API_TOURNAMENTS, {});
  }
}
